<template>
  <div class="sns-favorite-section">
    <h4 class="sns-favorite-section__title" v-if="headingLabel" v-text="headingLabel" />
    <favorite-selector-button-parts class="sns-favorite-section__card" @click="emitClick">
      <slot />
    </favorite-selector-button-parts>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import FavoriteSelectorButtonParts from '@/components/HomePage/HomePane/parts/FavoriteSelectorButtonParts.vue'

export type SnsFavoriteTypeData = 'driver' | 'team'

/**
 * HOME SNS 表示選手/チームセクション
 */
export default defineComponent({
  name: 'SnsFavoriteSection',
  components: {
    FavoriteSelectorButtonParts,
  },
  props: {
    headingLabel: {
      type: String,
      default: '',
    },
    viewType: {
      type: String as PropType<SnsFavoriteTypeData>,
      default: 'driver',
    },
  },
  methods: {
    emitClick() {
      this.$emit('click')
    },
  },
})
</script>

<style lang="scss" scoped>
.sns-favorite-section {
  display: flex;
  flex-flow: column nowrap;
  align-content: flex-start;
  justify-items: flex-start;
  width: 100%;
  padding: 0 16px;
  margin-bottom: 16px;

  &__title {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $gray50;
    text-align: left;
  }

  &__card {
    border: 1px solid $black10;
    border-radius: 8px;
  }
}
</style>
